import { SectionInstallPWA } from '@ferreri/prever-component-lib';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { PageLayoutMenuFooter } from '../components/PageLayoutMenuFooter';
import { SkeletonHomePage } from '../components/skeletons/SkeletonHomePage';
import { SETTINGS } from '../config/settings';
import { Home } from '../modules/home/Home';
import { useReconciliation } from '../modules/reconciliation/reconciliation.store';
import { PAGE_TITLE } from '../utils/pageTitle';

const PrivacyAndTermsCheck = dynamic(
  () => import('term/PrivacyAndTermsCheck'),
  {
    loading: () => null,
  },
);

export default function HomePage() {
  const router = useRouter();
  const { isLoading, doesNeedReconciliation, hasAccount, hasSession } =
    useReconciliation();

  useEffect(() => {
    if (!isLoading) {
      if (!hasSession) {
        window.location.assign(`${SETTINGS.public.urlAuthWeb}/identification`);
        return;
      }

      if (doesNeedReconciliation) {
        router.push('/reconciliation');
        return;
      }

      if (!hasAccount) {
        window.location.assign(
          `${SETTINGS.public.urlLinkWeb}/links/new/account`,
        );
        return;
      }
    }
  }, [doesNeedReconciliation, hasAccount, hasSession, router, isLoading]);

  if (isLoading) {
    return <SkeletonHomePage />;
  }

  return (
    <>
      <SectionInstallPWA />
      <PrivacyAndTermsCheck />
      <PageLayoutMenuFooter pageTitle={PAGE_TITLE.home}>
        <Home />
      </PageLayoutMenuFooter>
    </>
  );
}
